// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_hi","advertDetailParameterList__header":"c-n_hj","advertDetailParameterList__list":"c-n_hk"};